import classNames from 'utils/classNames';

function Section({ children, className }) {
  return (
    <section className={className}>
      <div className="mx-auto max-w-7xl px-4 py-20">{children}</div>
    </section>
  );
}

function Label({ className, eng_label, kor_label }) {
  return (
    <div
      className={classNames(
        className,
        'mb-20 flex w-full flex-wrap items-center justify-center gap-2 text-4xl font-bold text-slate-900 xs:text-5xl',
      )}
    >
      <div>{eng_label}</div>
      {kor_label && <div>({kor_label})</div>}
    </div>
  );
}

export { Section, Label };
